import { IonIcon } from "@ionic/react";
import { useRef } from "react";
import { OrganizationSwitcher } from "@/components/molecules/organization/organization-switcher";
import { SignedQueryImage } from "@/components/molecules/signed-query-image";
import { chevronDownIcon } from "@/lib/icons/chevron-down.icon";
import { useMyOrganizations } from "@/lib/query/organization/use-my-organizations";
import { queryOptions_signed_key_public_by_slug } from "@/lib/requests/file/file.get-signed-key";

export function OrganizationDropdown() {
  const modalRef = useRef<HTMLIonModalElement>(null);
  const { data: organizationsData } = useMyOrganizations();

  const organizations = organizationsData?.organizations ?? [];
  const hasMultipleOrganizations = organizations.length > 1;
  const organizationSlug = import.meta.env.VITE_ORGANIZATION_SLUG;
  const shouldShow =
    hasMultipleOrganizations && (!organizationSlug || organizationSlug === "boomer");

  if (!shouldShow) {
    return null;
  }

  const activeOrganization = organizations.find(
    (org) => org.id === organizationsData?.activeOrganizationId,
  );

  if (!activeOrganization) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        onClick={() => modalRef.current?.present()}
        className="flex items-center gap-2 rounded-lg py-1.5 pr-2 transition-opacity active:opacity-70"
      >
        {activeOrganization.slug && (
          <SignedQueryImage
            width={32}
            height={32}
            alt={activeOrganization.name ?? ""}
            className="size-8 rounded-md object-cover"
            {...queryOptions_signed_key_public_by_slug([
              "android-chrome-512x512.png",
              { slug: activeOrganization.slug },
            ])}
          />
        )}
        <span className="text-md font-medium text-txt-primary">{activeOrganization.name}</span>
        <IonIcon icon={chevronDownIcon} className="text-lg text-txt-primary" />
      </button>

      <OrganizationSwitcher ref={modalRef} />
    </>
  );
}
